module.exports = __webpack_public_path__ + "static/media/05.9bf4e6b9.png";